<template>
  <transition name="modal-fade">
    <div v-if="isOpen" class="action-modal-backdrop" @click="closeIfBackdrop($event)">
      <div class="action-modal" role="dialog">
        <!-- HEADER -->
        <header class="action-modal-header">
          <h2 class="action-modal-title">Plano de Ação - {{ categoryName }} ({{ monthName }}/{{ year }})</h2>
          <button class="action-close-button" @click="$emit('close')">&times;</button>
        </header>
        
        <!-- BODY -->
        <div class="action-modal-body">
          <div class="modal-content">
            <!-- Visão Geral -->
            <overview-section 
              :categoryData="categoryData" 
              :categoryName="categoryName"
              :month="month"
              :year="year"
              :monthName="monthName"
            />
            
            <!-- Estabelecimentos e Variações -->
            <establishments-variation-section 
              :categoryData="categoryData"
              :month="month" 
              :year="year"
            />
            
            <!-- Áreas de Intervenção -->
            <intervention-areas-section 
              :categoryData="categoryData"
              :categoryName="categoryName"
              :month="month"
            />
            
            <!-- Benchmarking -->
            <benchmarking-section 
              :categoryData="categoryData"
              :categoryName="categoryName"
            />
            
            <!-- Recomendações -->
            <recommendations-section 
              :categoryData="categoryData"
              :categoryName="categoryName"
              :month="month"
              :monthName="monthName"
            />
          </div>
        </div>
        
        <!-- FOOTER -->
        <footer class="action-modal-footer">
          <button class="action-print-btn" @click="printPlanReport">
            <i class="fas fa-print"></i> Imprimir Relatório
          </button>
          <button class="action-close-btn" @click="$emit('close')">Fechar</button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import OverviewSection from './Sections/OverviewSection.vue'
import EstablishmentsVariationSection from './Sections/EstablishmentsVariationSection.vue'
import InterventionAreasSection from './Sections/InterventionAreasSection.vue'
import RecommendationsSection from './Sections/RecommendationsSection.vue'

export default {
  components: {
    OverviewSection,
    EstablishmentsVariationSection,
    InterventionAreasSection,
    RecommendationsSection
  },
  props: {
    isOpen: Boolean,
    categoryData: Object,
    categoryName: String,
    month: Number,
    year: Number
  },
  computed: {
    monthName() {
      const monthNames = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]
      return monthNames[this.month - 1] || ''
    }
  },
  methods: {
    closeIfBackdrop(event) {
      if (event.target.className === 'action-modal-backdrop') {
        this.$emit('close')
      }
    },
    printPlanReport() {
      window.print()
    }
  }
}
</script>

<style scoped>
/* Estilos do Modal */
.action-modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.action-modal {
  background: #FFFFFF;
  border-radius: 10px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.25);
  width: 85vw;
  max-width: 1400px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  z-index: 10000;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.action-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(to right, #f8fafc, #f1f5f9);
}

.action-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  display: flex;
  align-items: center;
}

.action-modal-title::before {
  content: '';
  display: inline-block;
  width: 6px;
  height: 24px;
  background: #324DDD;
  margin-right: 12px;
  border-radius: 3px;
}

.action-close-button {
  background: none;
  border: none;
  font-size: 28px;
  color: #64748b;
  cursor: pointer;
  transition: color 0.2s;
}

.action-close-button:hover {
  color: #ef4444;
}

.action-modal-body {
  padding: 0;
  overflow-y: auto;
  max-height: calc(90vh - 150px);
}

.modal-content {
  padding: 30px;
}

.action-modal-footer {
  padding: 15px 30px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  background: #f8fafc;
}

.action-close-btn, .action-print-btn {
  padding: 10px 18px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-close-btn {
  background: #e2e8f0;
  color: #475569;
  border: none;
}

.action-close-btn:hover {
  background: #cbd5e1;
}

.action-print-btn {
  background: #324DDD;
  color: white;
  border: none;
}

.action-print-btn:hover {
  background: #2a3eb1;
}

/* Animações do Modal */
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

@media print {
  .action-modal {
    border: none;
    box-shadow: none;
    max-height: none;
    width: 100%;
    max-width: 100%;
    border-radius: 0;
  }
  
  .action-modal-body {
    overflow: visible;
    max-height: none;
  }
  
  .action-modal-footer, .action-close-button {
    display: none;
  }
}
</style> 